import React from 'react';

/**
 * 入退場管理QRコード検索フォーム
 * @params total {int} // 取得総数
 * @params isOpened {boolean} // 開閉フラグ
 * @params searchConditions {object} // 検索条件
 * @params callbacks {func} // イベントハンドラ
 */
export const EnterNameplatesSearchForm = ({
  total,
  isOpened,
  searchConditions,
  callbacks,
}) => (
  <div className='gate-schedulelist__searchform'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
          onClick={() => callbacks.handleOpen()}
        />
        <button className='btn-text--sm' onClick={() => callbacks.clear()}>
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>協力会社</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    placeholder='協力会社名'
                    value={searchConditions.company_name}
                    onChange={e =>
                      callbacks.set('company_name', e.target.value)
                    }
                    onBlur={() => callbacks.gets(() => {})}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>作業員</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='worker_name'
                    placeholder='作業員名'
                    value={searchConditions.worker_name}
                    onChange={e => callbacks.set('worker_name', e.target.value)}
                    onBlur={() => callbacks.gets(() => {})}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/searchmenus/EnterNameplates.jsx